import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import DownloadIcon from '@mui/icons-material/Download';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';

const InvoiceUploadedDocumentActions = ({
  documentKey,
  documentUrl,
  disableUpload,
  uploadTooltip,
  isUploading,
  onDownload,
  onUpload,
}) => (
  <Stack direction="row" spacing={2} justifyContent="flex-end" alignItems="center">
    <Button
      id={`downloadDocument-${documentKey}`}
      variant="link"
      color="primary"
      onClick={onDownload}
      disabled={!documentUrl}
      disableRipple
      endIcon={<DownloadIcon />}
      sx={{ p: 0, minWidth: 0, '& .MuiButton-endIcon': { ml: 0.5 } }}
    >
      Descargar
    </Button>
    <Tooltip
      title={uploadTooltip}
      placement="top"
      arrow
      componentsProps={{ tooltip: { sx: { fontSize: 13 } } }}
    >
      <span>
        <Button
          id={`uploadDocument-${documentKey}`}
          variant="link"
          color="primary"
          onClick={onUpload}
          disabled={disableUpload || isUploading}
          disableRipple
          endIcon={isUploading ? <CircularProgress size={16} color="inherit" /> : <CloudUploadOutlinedIcon />}
          sx={{ padding: 0, '& .MuiButton-endIcon': { ml: 0.5 } }}
        >
          Subir
        </Button>
      </span>
    </Tooltip>
  </Stack>
);

InvoiceUploadedDocumentActions.propTypes = {
  documentKey: PropTypes.string.isRequired,
  documentUrl: PropTypes.string,
  disableUpload: PropTypes.bool.isRequired,
  uploadTooltip: PropTypes.string,
  isUploading: PropTypes.bool.isRequired,
  onDownload: PropTypes.func.isRequired,
  onUpload: PropTypes.func.isRequired,
};

InvoiceUploadedDocumentActions.defaultProps = {
  documentUrl: null,
  uploadTooltip: '',
};

export default InvoiceUploadedDocumentActions;
